const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Barlow:wght@300;400;500;600;700&family=Source+Sans+3:wght@400;600;700&family=Trirong:wght@700;800&display=swap';

/**
 * Font loading and base typography. Rendered once by the Header so it ships in
 * both SSR output and the client bundle. Kept unlayered so it wins over the
 * preview shell's Tailwind base layer.
 */
export function ThemeStyles() {
  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="stylesheet" href={FONT_HREF} />
      <style>{`
        .vibesites-layout {
          font-family: var(--vibe-font-body);
          color: var(--vibe-color-text);
          background: var(--vibe-color-background);
          -webkit-font-smoothing: antialiased;
          text-rendering: optimizeLegibility;
        }
        .vibesites-layout h1, .vibesites-layout h2, .vibesites-layout h3,
        .vibesites-layout h4, .vibesites-layout h5, .vibesites-layout h6 {
          font-family: var(--vibe-font-heading);
        }
        .js-copy {
          font-family: var(--vibe-font-body);
          font-size: 1.0625rem;
          line-height: 1.85;
          letter-spacing: 0.02em;
        }
        @media (min-width: 768px) {
          .js-copy { font-size: 1.125rem; line-height: 1.95; }
        }
        .js-copy p + p { margin-top: 1em; }
        .js-copy strong, .js-copy b { font-weight: 600; }
        .js-copy a { text-decoration: underline; text-underline-offset: 3px; }
        .js-copy ul { list-style: disc; padding-left: 1.25em; margin-top: 0.75em; }
        .js-copy ol { list-style: decimal; padding-left: 1.25em; margin-top: 0.75em; }
        .js-heading {
          font-family: var(--vibe-font-heading);
          font-weight: 700;
          text-transform: uppercase;
          line-height: 1.05;
          letter-spacing: -0.005em;
        }
        /* Lead form block, restyled to the theme wherever it is embedded in a .js-contact section */
        .js-contact .mh-lead-form-card h2,
        .js-contact .mh-lead-form-card h3 {
          text-transform: uppercase;
          text-align: left !important;
          font-weight: 700 !important;
          font-size: clamp(1.625rem, 2.6vw, 2rem) !important;
          color: var(--vibe-color-text) !important;
        }
        .js-contact .mh-lead-form-card input,
        .js-contact .mh-lead-form-card select,
        .js-contact .mh-lead-form-card textarea {
          border-radius: var(--vibe-radius-md) !important;
        }
        .js-contact .mh-lead-form-submit-button {
          background-color: var(--vibe-color-secondary) !important;
          color: var(--vibe-color-text-on-secondary) !important;
          border-radius: var(--vibe-radius-md) !important;
          font-family: var(--vibe-font-heading) !important;
          font-weight: 700 !important;
          text-transform: uppercase;
          letter-spacing: 0.02em;
        }
        .js-contact .mh-lead-form-submit-button:hover {
          background-color: var(--vibe-color-primary) !important;
          color: var(--vibe-color-text-on-primary) !important;
        }
        .js-contact .mh-lead-form-submit-button {
          transition: background-color 250ms ease, color 250ms ease, transform 300ms var(--js-ease), box-shadow 300ms var(--js-ease) !important;
        }
        .js-contact .mh-lead-form-submit-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 22px -12px rgba(0, 0, 0, 0.45);
        }

        /* ---------- Motion ---------- */
        .vibesites-layout { --js-ease: cubic-bezier(0.16, 1, 0.3, 1); }
        html { scroll-behavior: smooth; }

        /* The editor wraps each slot in a block element as tall as the slot, which would
           pin a sticky header to nothing, so the wrapper itself becomes the sticky element. */
        div:has(> .js-site-header) { position: sticky; top: 0; z-index: 50; }

        .js-d1 { --reveal-delay: 90ms; }
        .js-d2 { --reveal-delay: 180ms; }
        .js-d3 { --reveal-delay: 270ms; }
        .js-d4 { --reveal-delay: 360ms; }
        .js-d5 { --reveal-delay: 450ms; }
        .js-d6 { --reveal-delay: 540ms; }

        [data-reveal="pending"].js-reveal { opacity: 0; transform: translate3d(0, 34px, 0); }
        [data-reveal="pending"].js-reveal-left { opacity: 0; transform: translate3d(-48px, 0, 0); }
        [data-reveal="pending"].js-reveal-right { opacity: 0; transform: translate3d(48px, 0, 0); }
        [data-reveal="pending"].js-reveal-zoom { opacity: 0; transform: scale(0.92); }
        [data-reveal="pending"].js-reveal-img { clip-path: inset(0 0 100% 0); }
        [data-reveal="pending"].js-reveal-img img { transform: scale(1.18); }
        [data-reveal="in"]:is(.js-reveal, .js-reveal-left, .js-reveal-right, .js-reveal-zoom) {
          transition: opacity 0.9s var(--js-ease), transform 1.1s var(--js-ease);
          transition-delay: var(--reveal-delay, 0ms);
        }
        [data-reveal="in"].js-reveal-img {
          transition: clip-path 1.2s var(--js-ease);
          transition-delay: var(--reveal-delay, 0ms);
        }
        [data-reveal="in"].js-reveal-img img {
          transition: transform 1.6s var(--js-ease);
          transition-delay: var(--reveal-delay, 0ms);
        }

        [data-reveal="pending"].js-stagger > * { opacity: 0; transform: translate3d(0, 22px, 0); }
        [data-reveal="in"].js-stagger > * {
          transition: opacity 0.7s var(--js-ease), transform 0.9s var(--js-ease);
          transition-delay: calc(var(--reveal-delay, 0ms) + var(--stagger-step, 70ms) * var(--i, 11));
        }
        .js-stagger > :nth-child(1) { --i: 0; }
        .js-stagger > :nth-child(2) { --i: 1; }
        .js-stagger > :nth-child(3) { --i: 2; }
        .js-stagger > :nth-child(4) { --i: 3; }
        .js-stagger > :nth-child(5) { --i: 4; }
        .js-stagger > :nth-child(6) { --i: 5; }
        .js-stagger > :nth-child(7) { --i: 6; }
        .js-stagger > :nth-child(8) { --i: 7; }
        .js-stagger > :nth-child(9) { --i: 8; }
        .js-stagger > :nth-child(10) { --i: 9; }
        .js-stagger > :nth-child(11) { --i: 10; }

        @keyframes js-enter-up { from { opacity: 0; transform: translate3d(0, 28px, 0); } to { opacity: 1; transform: none; } }
        @keyframes js-enter-fade { from { opacity: 0; } to { opacity: 1; } }
        @keyframes js-enter-zoom { from { opacity: 0; transform: scale(0.94); } to { opacity: 1; transform: none; } }
        @keyframes js-kenburns { from { transform: scale(1.14); } to { transform: scale(1); } }
        @keyframes js-grow-x { from { transform: scaleX(0); } to { transform: scaleX(1); } }
        .js-enter { animation: js-enter-up 1s var(--js-ease) both; animation-delay: var(--reveal-delay, 0ms); }
        .js-enter-fade { animation: js-enter-fade 0.35s ease-out both; animation-delay: var(--reveal-delay, 0ms); }
        .js-enter-zoom { animation: js-enter-zoom 0.45s var(--js-ease) both; animation-delay: var(--reveal-delay, 0ms); }
        .js-kenburns { animation: js-kenburns 2.8s var(--js-ease) both; }
        .js-grow-x { transform-origin: center; animation: js-grow-x 1.1s var(--js-ease) both; animation-delay: var(--reveal-delay, 0ms); }
        @keyframes js-slide-from-right { from { opacity: 0; transform: translate3d(56px, 0, 0); } to { opacity: 1; transform: none; } }
        @keyframes js-slide-from-left { from { opacity: 0; transform: translate3d(-56px, 0, 0); } to { opacity: 1; transform: none; } }
        .js-slide-from-right { animation: js-slide-from-right 0.45s var(--js-ease) both; }
        .js-slide-from-left { animation: js-slide-from-left 0.45s var(--js-ease) both; }
        .js-leave { opacity: 0 !important; transition: opacity 0.22s ease-in !important; }

        /* overflow-x: clip (unlike hidden) keeps the sticky header working while hiding side-slide overshoot */
        .vibesites-layout { overflow-x: clip; }
        @media (max-width: 767px) {
          [data-reveal="pending"]:is(.js-reveal-left, .js-reveal-right) { transform: translate3d(0, 34px, 0); }
        }

        .js-parallax { top: -12% !important; bottom: -12% !important; will-change: transform; }

        /* Buttons: lift on hover, press on click */
        .js-btn {
          position: relative;
          overflow: hidden;
          isolation: isolate;
          transition: background-color 250ms ease, border-color 250ms ease, color 250ms ease, transform 350ms var(--js-ease), box-shadow 350ms var(--js-ease);
        }
        .js-btn::after {
          content: '';
          position: absolute;
          inset: 0;
          z-index: -1;
          background: linear-gradient(110deg, transparent 30%, rgba(255, 255, 255, 0.22) 50%, transparent 70%);
          transform: translateX(-120%);
          transition: transform 700ms var(--js-ease);
          pointer-events: none;
        }
        .js-btn:hover { transform: translateY(-2px); box-shadow: 0 12px 24px -14px rgba(0, 0, 0, 0.55); }
        .js-btn:hover::after { transform: translateX(120%); }
        .js-btn:active { transform: translateY(0) scale(0.98); box-shadow: 0 4px 10px -8px rgba(0, 0, 0, 0.5); transition-duration: 120ms; }

        /* Image frames: slow zoom and a tightening inset border on hover */
        .js-zoom img { transition: transform 1.1s var(--js-ease); }
        .js-zoom:hover img { transform: scale(1.06); }
        .js-frame-line { transition: inset 700ms var(--js-ease), border-color 700ms ease; }
        .js-zoom:hover .js-frame-line { inset: 7%; border-color: rgba(255, 255, 255, 0.95); }

        @media (prefers-reduced-motion: reduce) {
          html { scroll-behavior: auto; }
          .js-enter, .js-enter-fade, .js-enter-zoom, .js-kenburns, .js-grow-x { animation: none !important; }
          .js-btn, .js-btn::after, .js-zoom img, .js-frame-line { transition: none !important; }
          .js-btn:hover, .js-btn:active, .js-zoom:hover img { transform: none !important; }
          .js-parallax { transform: none !important; }
        }
        @media print {
          [data-reveal], [data-reveal] > *, [data-reveal] img { opacity: 1 !important; transform: none !important; clip-path: none !important; }
        }
      `}</style>
    </>
  );
}

export default ThemeStyles;
